const boldMain = (desc, code, isMain) => {
  let branch = code.length > 4 ? code : code + " - " + desc;

  if (isMain) {
    return {
      __html: branch.bold()
    };
  }
  return {
    __html: branch
  };
};

export default boldMain;
